export default "__VITE_ASSET__CTip8OQU__"